module.exports = __webpack_public_path__ + "media/images/weather/158_day-6af0d39e2466ca419344c66ff0ab7634.png";